import React from 'react'
import { Button } from '@UILibrary/Button'

import { backupCodesFilename } from '../utils'
import styles from '../security-settings.module.sass'

type Props = {
  codes: string[]
  onDismiss: () => void
}

// The plaintext codes exist only in this response — the server keeps digests —
// so this panel is the one and only chance the user has to write them down.
export const BackupCodes = ({ codes, onDismiss }: Props) => {
  const download = () => {
    const blob = new Blob([codes.join('\n')], { type: 'text/plain' })
    const link = document.createElement('a')

    link.href = URL.createObjectURL(blob)
    link.download = backupCodesFilename()
    link.click()
    URL.revokeObjectURL(link.href)
  }

  const codeItems = codes.map((code) => <li key={code}>{code}</li>)

  return (
    <div className={`${styles.panel} ${styles.backupCodes}`}>
      <h3>Save your backup codes</h3>
      <p>
        Each code works once, and lets you sign in when you cannot reach your authenticator app —
        without waiting for an SMS. We cannot show them again.
      </p>

      <ul className={styles.codeList}>{codeItems}</ul>

      <div className={styles.actions}>
        <Button variant="secondary" onClick={download}>Download</Button>
        <Button variant="primary" onClick={onDismiss}>I have saved them</Button>
      </div>
    </div>
  )
}
